import React from 'react';
import useScrollReveal from '../../common/hooks/useScrollReveal';
import './Reveal.scss';

/**
 * Reveal wrapper - anime les enfants au scroll
 * @param {string} animation - fadeUp | fadeIn | fadeLeft | fadeRight | scaleIn | slideUp
 * @param {number} delay - delai en ms
 * @param {number} duration - duree en ms
 */
export default function Reveal({ children, animation = 'fadeUp', delay = 0, duration = 800, className = '', style = {} }) {
    const [ref, isVisible] = useScrollReveal();

    return (
        <div
            ref={ref}
            className={`reveal reveal-${animation} ${isVisible ? 'revealed' : ''} ${className}`}
            style={{
                ...style,
                transitionDelay: `${delay}ms`,
                transitionDuration: `${duration}ms`,
            }}
        >
            {children}
        </div>
    );
}
